const BooleanFormatter = ({ value }) => {
    if (value == null) return '';

    if (value === false) return 'N';

    return 'Y';
};

export default BooleanFormatter;
